module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-staffie-7b7659bc.svg";